import { Injectable } from '@angular/core';
import Dexie from 'dexie';
import { Messages, Attachments, AdvalvasItems, Tasks, WerkbonType, Afdelingen, Categories, MessageTemplates, Rooms, AllMyUsers, Users, Calendars, CalendarItems } from '../../Interface/CommonDataBaseInterface'


@Injectable()
export class DatabaseProvider extends Dexie {

	public advalvas: Dexie.Table<AdvalvasItems, string>;

	public messages: Dexie.Table<Messages, string>;
	public attachments: Dexie.Table<Attachments, string>;

	public tasks: Dexie.Table<Tasks, string>;

	public users: Dexie.Table<Users, string>;

	public werkbonType: Dexie.Table<WerkbonType, string>;
	public afdelingen: Dexie.Table<Afdelingen, string>;
	public categories: Dexie.Table<Categories, string>;
	public rooms: Dexie.Table<Rooms, string>;

	public messageTemplates: Dexie.Table<MessageTemplates, string>;

	public myUsers: Dexie.Table<AllMyUsers, string>;

	public calendars: Dexie.Table<Calendars, string>;
	public calendarItems: Dexie.Table<CalendarItems, string>;

	public db = new Dexie('OpyxDB');

	public constructor() {

		super("OpyxDB");
		var db = this;

		db.version(1).stores({
			messages: "id,conversationid,appstatus",
			attachments: "id",
			advalvas: "id",
			tasks: "id,appstatus",
			users: "id",
			werkbontype: "id",
			afdelingen: "id",
			categories: "id",
			rooms: "id",
			messagetemplates: "id",
			myusers: "id",
			calendars: "id",
			calendaritems: "id,appstatus",
		});

		this.advalvas = this.table('advalvas');

		this.messages = this.table("messages");
		this.attachments = this.table("attachments");

		this.tasks = this.table('tasks');

		this.users = this.table('users');

		this.werkbonType = this.table('werkbontype');
		this.afdelingen = this.table('afdelingen');
		this.categories = this.table('categories');
		this.rooms = this.table('rooms');

		this.messageTemplates = this.table('messagetemplates');

		this.myUsers = this.table('myusers');

		this.calendars = this.table("calendars");
		this.calendarItems = this.table("calendaritems");

	}

}



// WEBPACK FOOTER //
// ./src/providers/database/database.ts